import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import PublicIcon from '@mui/icons-material/Public';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import { useNavigate } from 'react-router-dom';


export default function ScenarioMenu() {
  const navigate = useNavigate();
  return (
    <React.Fragment>
        <MenuItem
            disabled={true}
        >
            <Typography>Edit Design</Typography>
        </MenuItem>
        <MenuItem
            onClick={() => navigate('/scenario/sat')}
        >
          <ListItemIcon>
            <SatelliteAltIcon fontSize="small" />
          </ListItemIcon>
          Satellite
        </MenuItem>
        <MenuItem
            onClick={() => navigate('/scenario/mission')}
        >
          <ListItemIcon>
            <PublicIcon fontSize="small" />
          </ListItemIcon>
          Orbit
        </MenuItem>
        <MenuItem
            onClick={() => navigate('/scenario/orientation')}
        >
          <ListItemIcon>
            <AutoModeIcon fontSize="small" />
          </ListItemIcon>
          Orientation
        </MenuItem>
    </React.Fragment>
  );
}